export const CHAT_TAGS = {
  CHAT_TAG: "Chat",
};
